<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row">
      <mat-form-field fxFlex="100">
        <mat-label>Nazwa</mat-label>
        <input matInput placeholder="Nazwa" [formControl]="nameControl" [required]="true">
        <mat-error *ngIf="nameControl.hasError('required')">To pole jest wymagane</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row">
      <app-dict-insurance-companies
        fxFlex="100" label="TU" [required]="true"
        [control]="insuranceCompanyControl"
        (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
        [hideChildren]="true"
      ></app-dict-insurance-companies>
    </div>

    <div fxLayout="row">
      <app-dict
        fxFlex="100"
        [control]="policyTypesControl"
        [multiple]="true"
        dictType="sold_policy_type"
        label="Typ polisy"
      ></app-dict>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!riskDictionaryForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button (click)="closeDialog()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

